<!-- Sign In using OTP  -->
<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 p-0">
          <div class="login-left-wrap login-otp-left-wrap">
            <div class="back-icon text-start">
              <router-link to="/login-password" class="ms-0 ps-0"
                >Back</router-link
              >
            </div>
            <div class="left-login">
              <div class="rep-icon-login">
                <img
                  src="../../assets/images/member-login.svg"
                  alt="image-fluid"
                />
              </div>
              <div class="">
                <!-- <router-link to="/smart-login">
                  <button class="qr-login-btn">
                    <img
                    src="../../assets/images/qr-icon.svg"
                        alt="qr icon"
                        class="me-2"
                    />Login with QR
                  </button>
                </router-link> -->
              </div>
            </div>
            <h4 class="login-title mb-1">Login to Continue</h4>
            <div class="auth-form pt-3 pb-3">
              <div class="email-change-wrap">
                <div class="">{{ email }}</div>
                <div class="login-highlight" @click="routeToLogin">Change</div>
              </div>
              <form class="new-login-otp-form">
                <div class="mt-3">
                  <div class="d-flex">
                    <div class="">
                      <label class="opt-label mt-0"
                        >Enter OTP<span class="required-label">*</span></label
                      >
                    </div>
                  </div>

                  <div class="opt-num-wrap">
                    <div>
                      <v-otp-input
                        @on-complete="onChangeOTP"
                        @on-change="handleOnChange"
                        ref="otpInput"
                        :input-classes="errorClass + ' otp-input'"
                        separator="-"
                        :num-inputs="6"
                        :should-auto-focus="true"
                        :is-input-num="true"
                        input-type="text"
                      />
                    </div>
                  </div>

                  <div class="valid-error mt-2" v-if="otpErrorFlag">
                    {{ errorMsg }}
                  </div>
                </div>
              </form>

              <!-- login btn -->
              <button
                @click="verifyToken"
                class="submit-btn mt-3 next-btn"
                type="button"
                :disabled="otp.length !== 6 || formLoader"
              >
                <b-spinner v-if="formLoader" small />
                Login
              </button>
              <login-otp
                @sendOTP="sendOTP"
                :expirySecond="60"
                :setSpinnerLoader="otpLoader"
                @resendOtpHandler="resendOtpHandler"
              />

              <!-- sign in using otp  -->
              <!-- <div class="left-login mt-2 mb-0">
                <div class="login-highlight" @click="generateOTP">
                  <b-spinner v-if="otpLoader && !(loginLoader)" small></b-spinner>
                    Sign In using OTP
                  </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 p-0">
          <login-in-carsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "@/resource/MemberApi";
import NewLoginOtp from "./NewLoginOtp.vue";
import helper from "@/resource/Helper";
import store from "../../store/store";
import Logincarsoule from "./Logincarsoule";
export default {
  name: "LoginOtp",
  components: {
    "login-in-carsoule": Logincarsoule,
    "login-otp": NewLoginOtp,
  },
  data() {
    return {
      otp: "",
      errorClass: "",
      otpLoader: false,
      formLoader: false,
      otpErrorFlag: false,
      errorMsg: "",
      setSpinnerLoader: false,
      isResend: false,
    };
  },
  computed: {
    ...mapGetters({
      deviceId: "deviceId",
      email: "memberEmail",
    }),
  },
  methods: {
    routeToLogin() {
      let app = this;
      app.$router.push("/");
    },
    resendOtpHandler() {
      this.isResend = true;
    },
    onChangeOTP(otp) {
      let app = this;
      app.otp = otp;
      app.verifyToken();
    },
    verifyToken() {
      let app = this;
      if (!this.otp || this.otp.trim() === "") {
        app.otpErrorFlag = true;
        app.errorClass = "highlight_otp";
        app.errorMsg =
          "Please enter  OTP sent to your registered email  to proceed";
      } else if (app.otp.length < 6) {
        app.otpErrorFlag = true;
        app.errorClass = "highlight_otp";
        app.errorMsg = "Please enter  6 digit OTP inorder to proceed";
      } else {
        app.formLoader = true;
        app.errorClass = false;
        Api.post("v2/auth/validate-otp", {
          email: app.email,
          device_id: app.deviceId,
          verification_code: app.otp,
          user_type: "M",
        })
          .then((response) => {
            if (response.data.status == "success") {
              store.commit("setAuthentication", true);
              helper.setLoginDetails(response.data);
            }
          })
          .catch((error) => {
            app.errorClass = "highlight_otp";
            if (error.response.data.status == "error") {
              app.otpErrorFlag = true;
              app.errorMsg = error.response.data.message;
              app.setSpinnerLoader = false;
            }
            app.verifyLoader = false;
          })
          .finally(() => {
            app.formLoader = false;
            app.setSpinnerLoader = false;
          });
      }
    },
    handleOnChange() {
      let app = this;
      if (app.otpErrorFlag) {
        app.otpErrorFlag = false;
        app.errorClass = "";
        app.errorMsg = "";
      }
    },
    changeResendStatus() {
      console.log("Hello");
      this.isResend = true;
    },
    sendOTP() {
      let app = this;
      app.otpLoader = true;
      app.$store.commit("setAuthentication", false);
      Api.post("v2/auth/generate-otp", {
        email: app.email,
        device_id: app.deviceId,
        type: `email`,
        user_type: "M",
        is_resend: this.isResend,
      })
        .then(function (response) {
          if (response.data.status == "success") {
            app.otpLoader = false;
            helper.infoMessage(
              app,
              response.data.status,
              response.data.message
            );
          }
        })
        .catch(function (error) {
          if (error.response.data.status == "error") {
            app.otpLoader = false;
            helper.infoMessage(
              app,
              error.response.data.status,
              error.response.data.message
            );
          }
        });
    },
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
/* .rep-icon-login img {
  width: 100px;
} */

.new-login-wrapper .highlight_otp {
  border: 2px solid #dc3545 !important;
}

.new-login-wrapper .valid-error {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 14px;
}

.resend-timer-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}
</style>

<style scoped>
.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>